module.exports = __webpack_public_path__ + "img/leche.ff54c53e.jpg";